var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0711 19.8762L20.5684 7.52133C20.5963 6.82867 20.2564 6.17343 19.6735 5.79135L18.8176 5.23184L15.6651 3.1692L15.604 3.12894C15.573 3.10856 15.5418 3.08939 15.5102 3.07126C15.4935 3.06176 15.4762 3.05248 15.4588 3.0432C15.0987 2.84846 14.6917 2.7711 14.2934 2.81371C14.0362 2.84072 13.7823 2.91743 13.5471 3.04477L9.23851 5.38002C8.6237 5.71358 8.22943 6.34211 8.20162 7.03685L7.70439 19.3871C7.67924 20.0176 7.91599 20.5977 8.31767 21.025C8.64496 21.3738 9.08256 21.6209 9.57829 21.7105C9.6838 21.7297 9.79211 21.7418 9.90269 21.7466L10.9294 21.787L17.6903 22.0544C18.9548 22.1045 20.0207 21.1291 20.0711 19.8762ZM13.628 8.1458C13.5921 8.15451 13.5572 8.16249 13.522 8.16892C13.5067 8.17213 13.4905 8.17478 13.4753 8.17671C13.4249 8.18377 13.3742 8.18798 13.3243 8.1894C13.3072 8.19019 13.2907 8.19076 13.2743 8.19003C13.2571 8.19082 13.2399 8.19032 13.2239 8.1891C12.6602 8.16431 12.1533 7.78313 11.9993 7.21378C11.8093 6.50945 12.2299 5.7875 12.9397 5.59943C13.5866 5.4272 14.2493 5.75858 14.5056 6.35261C14.5227 6.39229 14.5386 6.43399 14.5524 6.47714C14.5573 6.49523 14.5633 6.51259 14.5684 6.53151C14.7585 7.23449 14.3379 7.95644 13.628 8.1458Z",
    fill: "url(#paint0_linear_6462_231)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70407 19.3869C7.67892 20.0173 7.91567 20.5975 8.31735 21.0248C8.64464 21.3736 9.08224 21.6207 9.57797 21.7103C9.68348 21.7295 9.79179 21.7416 9.90237 21.7464L10.9291 21.7868L17.69 22.0542C18.9545 22.1044 20.0204 21.1289 20.0708 19.8761L20.3031 14.1044L18.8391 8.68895C18.8021 8.47379 18.7296 8.26308 18.6203 8.06619L18.1253 7.17576L16.2669 3.83336C16.1145 3.55921 15.9016 3.33085 15.6505 3.15955L15.608 3.13156C15.5948 3.12301 15.5812 3.1149 15.5678 3.10666C15.5509 3.0961 15.534 3.08529 15.5169 3.07541C15.486 3.05774 15.4544 3.04133 15.4225 3.02527C15.4097 3.01867 15.3967 3.01246 15.3838 3.00617C15.1086 2.87495 14.8022 2.80517 14.4858 2.81037L14.2921 2.81358C14.0352 2.84069 13.7817 2.91734 13.5468 3.04451L9.23817 5.37976C8.62336 5.71332 8.22909 6.34185 8.20128 7.03659L7.70407 19.3869ZM12.9393 5.59916C13.5863 5.42694 14.249 5.75832 14.5053 6.35235C14.5224 6.39203 14.5383 6.43373 14.5521 6.47687C14.557 6.49497 14.563 6.51233 14.5681 6.53125C14.7581 7.23433 14.3376 7.95621 13.6277 8.1456C13.5918 8.15431 13.5569 8.16229 13.5217 8.16871C13.5064 8.17193 13.4901 8.17458 13.4749 8.17651C13.4245 8.18357 13.3738 8.18777 13.324 8.1892C13.3068 8.18999 13.2904 8.19055 13.274 8.18983C13.2568 8.19062 13.2396 8.19012 13.2236 8.18889C12.6599 8.1641 12.1529 7.78292 11.999 7.21358C11.809 6.50925 12.2295 5.7873 12.9393 5.59916Z",
    fill: "url(#paint1_linear_6462_231)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6204 8.06714L18.1254 7.17671L16.267 3.83435C15.9102 3.19296 15.2249 2.79924 14.4859 2.81138L9.57568 2.8928C8.87487 2.90424 8.23117 3.27931 7.88055 3.88123L1.64525 14.5857C1.01271 15.6716 1.38813 17.0603 2.48428 17.6875L9.23406 21.5501C10.3297 22.1771 11.7307 21.8049 12.3633 20.719L18.6009 10.0107C18.9506 9.41043 18.9573 8.6739 18.6204 8.06714ZM11.999 7.21427C11.8092 6.51045 12.2298 5.78839 12.9393 5.59999C13.5863 5.42817 14.249 5.75955 14.5053 6.3531C14.5228 6.39306 14.5384 6.43496 14.5519 6.47787C14.5573 6.49587 14.563 6.51337 14.568 6.53199C14.7581 7.23519 14.3375 7.95729 13.6277 8.14627C13.5923 8.1552 13.5571 8.16356 13.5219 8.16963C13.5065 8.17278 13.4905 8.17562 13.4752 8.17733C13.4249 8.18451 13.374 8.18903 13.324 8.1904C13.307 8.19114 13.2902 8.19131 13.2739 8.1909C13.2569 8.19164 13.2399 8.1909 13.2238 8.18996C12.6597 8.16507 12.153 7.78377 11.999 7.21427Z",
    fill: "url(#paint2_linear_6462_231)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3633 20.7184C12.3633 20.7184 12.3908 20.671 12.4417 20.5837L9.62808 10.181C9.48908 9.82856 9.20694 9.53046 8.78131 9.2869C7.84639 8.75189 7.13024 8.91127 6.63292 9.76505L5.73532 11.306C5.46609 11.7682 5.40861 12.1833 5.55915 12.5521L7.76409 20.7083L9.23402 21.5495C10.3296 22.1764 11.7307 21.8043 12.3633 20.7184Z",
    fill: "url(#paint3_linear_6462_231)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4777 11.5872C13.4303 11.4584 13.3504 11.3617 13.2375 11.2971C13.0838 11.2091 12.9427 11.2117 12.8141 11.3047L4.51544 16.7562C4.45923 16.7888 4.41496 16.8329 4.38266 16.8884C4.32609 16.9855 4.31328 17.0962 4.34432 17.2205L4.83441 19.0334L9.234 21.551C10.3296 22.178 11.7307 21.8059 12.3632 20.72C12.3632 20.72 13.1766 19.3235 14.1899 17.5841L14.8017 16.5336L13.4777 11.5872Z",
    fill: "url(#paint4_linear_6462_231)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2169 16.3411C12.0779 15.9887 11.7958 15.6906 11.3702 15.4471C10.4353 14.912 9.71911 15.0714 9.22178 15.9252L8.32418 17.4662C8.05496 17.9284 7.99748 18.3434 8.14802 18.7122L8.85673 21.3338L9.23412 21.5498C10.3297 22.1767 11.7308 21.8046 12.3633 20.7187C12.3633 20.7187 12.6403 20.2432 13.0719 19.5023L12.2169 16.3411Z",
    fill: "url(#paint5_linear_6462_231)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7356 11.3058L6.6332 9.76487C7.13052 8.91109 7.84667 8.75171 8.78159 9.28672C9.20718 9.53026 9.48939 9.82841 9.62836 10.1808C9.76706 10.5333 9.70716 10.9318 9.44848 11.3759L8.55088 12.9168C8.29208 13.3611 7.97389 13.6117 7.59662 13.6688C7.21911 13.7258 6.81764 13.6325 6.39206 13.3889C5.45711 12.854 5.23829 12.1596 5.7356 11.3058ZM6.49155 11.7152C6.25833 12.1156 6.3606 12.4409 6.79832 12.6914C7.24292 12.9458 7.58187 12.873 7.81509 12.4726L8.69243 10.9665C8.92554 10.5663 8.81978 10.2388 8.37519 9.98433C7.93742 9.73383 7.602 9.80887 7.36889 10.2091L6.49155 11.7152ZM4.38292 16.8866C4.41524 16.8311 4.45949 16.7871 4.5157 16.7544L12.8144 11.303C12.943 11.21 13.0841 11.2074 13.2377 11.2953C13.3507 11.3599 13.4306 11.4567 13.478 11.5855C13.5252 11.7145 13.5165 11.8345 13.4519 11.9454C13.4195 12.0011 13.3767 12.0505 13.3235 12.094L5.04271 17.5141C4.903 17.6099 4.7459 17.6081 4.57141 17.5082C4.45133 17.4395 4.37583 17.3429 4.34456 17.2188C4.31352 17.0944 4.32632 16.9838 4.38292 16.8866ZM8.31183 17.4871L9.21627 15.9344C9.71737 15.0742 10.4354 14.9116 11.3703 15.4466C11.7959 15.6901 12.0777 15.9891 12.2157 16.3431C12.3535 16.697 12.2922 17.0979 12.0315 17.5455L11.1271 19.0981C10.8663 19.5458 10.5467 19.7989 10.1685 19.8576C9.79012 19.9161 9.38818 19.8236 8.96259 19.58C8.02763 19.045 7.81073 18.3474 8.31183 17.4871ZM9.06609 17.8994C8.83025 18.3043 8.93115 18.632 9.36888 18.8825C9.81348 19.1369 10.1537 19.0618 10.3896 18.6568L11.2772 17.1331C11.513 16.7283 11.4086 16.3985 10.964 16.1441C10.5262 15.8936 10.1894 15.9709 9.95367 16.3757L9.06609 17.8994Z",
    fill: "url(#paint6_linear_6462_231)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6011 10.0104L16.4809 13.6504L14.5998 6.69232C14.5927 6.63901 14.5824 6.58527 14.5684 6.53209C14.5633 6.51323 14.5573 6.49585 14.5524 6.47772C14.5488 6.46563 14.5448 6.45401 14.54 6.44268C14.5299 6.41164 14.5179 6.38153 14.5056 6.35323C14.2612 5.78723 13.6479 5.45958 13.0307 5.57972L14.6413 2.81466C15.2521 2.85173 15.8121 3.16494 16.1596 3.66223C16.1982 3.71687 16.2343 3.77471 16.2674 3.83425L18.1259 7.17654L18.6205 8.06714C18.9574 8.67342 18.9508 9.41013 18.6011 10.0104Z",
    fill: "url(#paint7_linear_6462_231)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9936 7.37108C12.5769 7.13263 12.4341 6.60448 12.6747 6.19148L15.725 0.954864C15.9656 0.541863 16.4985 0.400347 16.9151 0.638793C17.3318 0.877239 17.4746 1.40539 17.234 1.81839L14.1837 7.05497C13.9432 7.46803 13.4103 7.60952 12.9936 7.37108Z",
    fill: "url(#paint8_linear_6462_231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6462_231",
    x1: 8.4524,
    y1: 7.41571,
    x2: 16.3192,
    y2: 16.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6462_231",
    x1: 19.4804,
    y1: 16.4758,
    x2: 11.9553,
    y2: 12.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6462_231",
    x1: 7.9246,
    y1: 4.33243,
    x2: 10.9051,
    y2: 15.5548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6462_231",
    x1: 8.6982,
    y1: 15.4668,
    x2: 7.39018,
    y2: 10.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6462_231",
    x1: 10.452,
    y1: 20.1049,
    x2: 8.43817,
    y2: 12.5223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6462_231",
    x1: 11.6723,
    y1: 23.0545,
    x2: 9.67925,
    y2: 15.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6462_231",
    x1: 10.2008,
    y1: 12.164,
    x2: 4.82408,
    y2: 21.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6462_231",
    x1: 17.5647,
    y1: 10.7143,
    x2: 12.416,
    y2: 2.03201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6462_231",
    x1: 14.5837,
    y1: 3.79328,
    x2: 15.9855,
    y2: 4.60982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountPercentIcon);
export default __webpack_public_path__ + "static/media/discount-percent-icon.e14284e1e92213e147a9f0e5056b264c.svg";
export { ForwardRef as ReactComponent };